// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-loader {
	border-color: #f3f3f3;
	border-style: solid;
	border-radius: 50%;
	border-top-color: #00525d;
	animation: spin 1s linear infinite;
}

/* Safari */

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
`, "",{"version":3,"sources":["webpack://./src/layout/miniLoader/miniLoader.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;CAClB,yBAAyB;CAEzB,kCAAkC;AACnC;;AAEA,WAAW;;AAWX;CACC;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;AACD","sourcesContent":[".mini-loader {\n\tborder-color: #f3f3f3;\n\tborder-style: solid;\n\tborder-radius: 50%;\n\tborder-top-color: #00525d;\n\t-webkit-animation: spin 1s linear infinite;\n\tanimation: spin 1s linear infinite;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t}\n\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t}\n}\n\n@keyframes spin {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
